<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M5.333 8.328c0-.92.752-1.667 1.68-1.667h13.77c.927 0 1.679.746 1.679 1.667v19.338c0 .92-.752 1.667-1.68 1.667H7.012a1.674 1.674 0 01-1.679-1.667V8.328z"/><path fill-rule="evenodd" d="M11.726 2.666a1.004 1.004 0 00-1.013.995 1.004 1.004 0 001.002 1.005l12.93.074v12.923c0 .553.451 1 1.008 1 .556 0 1.007-.447 1.007-1V3.858a1.004 1.004 0 00-.996-1.112l-13.938-.08z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsCopyFilled'
}
</script>
